import { format } from 'date-fns/esm';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { Card, CardBody, Container } from 'shards-react';
import { userActivities } from '../Complaint/userQueries';

const mapState = (state, ownProps) => ({
  profile: state.firebase.profile,
  activities: state.firebase.ordered.activities || [],
  auth: state.firebase.auth,
  loading: state.async.loading,
});

class Activities extends Component {
  render() {
    const { activities } = this.props;
    //console.log(this.props);
    return (
      <Container fluid className='h-100 my-3'>
        <h5 className='text-capitalize'>Notification</h5>
        <Card small className='my-3'>
          <CardBody className='p-0 pb-3'>
            <table className='table mb-0'>
              <thead className='bg-light'>
                <tr>
                  <th scope='col' className='border-0 '>
                    Date
                  </th>
                  <th scope='col' className='border-0'>
                    Complaint
                  </th>

                  <th scope='col' className='border-0'>
                    Edited By
                  </th>
                  <th scope='col ' className='border-0'>
                    Activity
                  </th>
                </tr>
              </thead>
              <tbody>
                {activities &&
                  activities
                    .sort(
                      (a, b) =>
                        new Date(b.value.createdAt) -
                        new Date(a.value.createdAt)
                    )
                    .map((activity) => (
                      <tr key={activity.key}>
                        <td className='text-capitalize caption '>
                          {(activity.value.createdAt &&
                            format(
                              new Date(activity.value.createdAt),
                              'dd MMM yyyy HH:mm'
                            )) ||
                            ''}
                        </td>
                        <td className='text-capitalize  caption'>
                          {activity.value.complaintId}
                        </td>

                        <td className='text-capitalize caption '>
                          {activity.value.editedBy} <br />
                          {activity.value.editor_role}
                        </td>
                        <td className=' text-wrap caption'>
                          {activity.value.message}
                        </td>
                      </tr>
                    ))}
              </tbody>
            </table>
          </CardBody>
        </Card>
      </Container>
    );
  }
}
export default compose(
  connect(mapState, null),
  firebaseConnect((auth, profile) => userActivities(auth, profile))
)(Activities);
